module.exports = __webpack_public_path__ + "static/media/COLA.e9a6b86a.JPG";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/COLA.JPG
// module id = 1311
// module chunks = 1